import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ConnectCCP from '../../comps/Call/ConnectCCP';
import { Box, Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';

const CallCenter = () => {
	const location = useLocation();

	// for notification after user has clicked save in edit modal
	const [notificationState, setNotificationState] = useState(null); // used to open/close the notificaiton
	const [notificationMessage, setNotificationMessage] = useState(''); // used to set error message

	// // submit status updated after user has clicked save in edit modal
	const [statusClass, setStatusClass] = useState(''); // keeps track of status when data is posted

	let number = location.pathname.split('/')[3];
	let homeId = location.pathname.split('/')[4];
	if (number && !isNaN(+number)) {
		number = '+1' + number;
	}

	const memoizedCCP = useMemo(
		() => (
			<ConnectCCP
				phoneNumber={{ num: number, id: homeId }}
				setNotificationState={setNotificationState}
				setNotificationMessage={setNotificationMessage}
				setStatusClass={setStatusClass}
			/>
		),
		[number, homeId]
	);

	return (
		<>
			<Snackbar
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				open={notificationState}
				autoHideDuration={4500}
				onClose={() => setNotificationState(false)}
			>
				<Alert
					onClose={() => setNotificationState(false)}
					severity={statusClass}
					variant="filled"
				>
					{notificationMessage}
				</Alert>
			</Snackbar>
			<Box sx={{ width: '25%', minWidth: '400px', height: '80vh' }}>{memoizedCCP}</Box>
		</>
	);
};

export default CallCenter;
